import {useState} from 'react';
import {mrbgStore} from './mrbg/mrbgRedux';

function BlogArea({mainStyle}){

	const [mrbgVars,setMrbgVars] = useState(mrbgStore.getState().mrbgVars);


	return(
		<section id={mainStyle.areaSec} className={mainStyle.prl_Y}>
			{ mrbgVars.pageInfo.areaTitle? <h2 id={mainStyle.areaTitle}>{mrbgVars.pageInfo.areaTitle}</h2>: '' }
			<div id={mainStyle.areaBody}>
				{
					mrbgVars.areaInfo?.single? <AreaTable {...{areaInfo:mrbgVars.areaInfo?.single,caption:'جدول نواحی',mainStyle}} />: ''

				}
				{
					mrbgVars.areaInfo?.package? <AreaTable {...{areaInfo:mrbgVars.areaInfo?.package,caption:'جدول پکیج‌ها',mainStyle}} />: ''
				}
			</div>
		</section>
	)
}
function AreaTable({areaInfo,caption,mainStyle}){

	const tdTh = {
		'name': 'ناحیه',
		'gender': 'جنسیت',
		'duration': 'زمان',
		'requiredSessions': 'تعداد جلسات',
		'price': 'بهای هر جلسه',
		'discount': 'تخفیف',
		'finalPrice': 'قیمت نهایی'
	}

	return(
		<div className={mainStyle.areaTblFrame}>
			<table className={mainStyle.areaTbl}>
				<caption>{caption}</caption>
				<thead>
				<tr>
					{
						Object.keys(tdTh).map((th,i)=>{
							return <th key={i}>{tdTh[th]}</th>
						})
					}
				</tr>
				</thead>
				<tbody>
				{
					Object.keys(areaInfo).map((key,i)=>{
						return(
							<tr key={i}>
								<td>{areaInfo[key].name}</td>
								<td>{areaInfo[key].gender}</td>
								<td>{areaInfo[key].duration} دقیقه</td>
								<td>{areaInfo[key].requiredSessions} جلسه</td>
								<td>{areaInfo[key].price.toPrice()} تومان</td>
								<td>{areaInfo[key].discount.toPrice()} تومان</td>
								<td>{(areaInfo[key].price-areaInfo[key].discount).toPrice()} تومان</td>
							</tr>
						)
					})
				}
				</tbody>
			</table>
		</div>
	)
}
export default BlogArea;